import { startMsalApp } from '@higgins/ui';
import App from './app';
import { msalInstance, API_SCOPES } from './lib/msal';
import './index.css';

// Keep a copy of the app on the device so it opens with no signal (docs/OFFLINE.md).
// Built apps only — `vite` dev serves no sw.js.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch((err) => console.error('[sw]', err));
}

// Sign in as the user the portal names (login_hint), then render (#242).
void startMsalApp({ msal: msalInstance, scopes: API_SCOPES, app: <App /> });
